import React from 'react';

export interface Alert {
    uuid: string;
    variant: AlertVariant;
    text: string | React.ReactNode;
    screen?: AlertScreen;
}

export enum AlertVariant {
    Default = 'default',
    Info = 'info',
    Success = 'success',
    FormAddPet = 'formAddPet'
}

export enum AlertScreen {
    OnlineBookingSignin = 'OnlineBookingSignin',
    OnlineBookingSignup = 'OnlineBookingSignup',
    OnlineBookingSelectDateTime = 'OnlineBookingSelectDateTime',
    OnlineBookingNotesAndAgreements = 'OnlineBookingNotesAndAgreements',

    // Intake Form
    IntakeFormCustomer = 'IntakeFormCustomer',

    // Form Invitation
    FormInvitationCustomer = 'FormInvitationCustomer',
    FormInvitationPet = 'FormInvitationPet'
}
